import React from "react";

// Official InZeAir logo (emblem cropped from the brand lockup, on royal-blue tile).
// Full lockup available at /inzeair-logo.jpg
export function LogoMark({ size = 40 }) {
  return (
    <div
      className="rounded-xl overflow-hidden shrink-0 shadow-sm ring-1 ring-white/10"
      style={{ width: size, height: size, background: "#14219E" }}
      data-testid="logo-mark"
    >
      <img src="/inzeair-mark.png" alt="InZeAir" className="w-full h-full object-cover" />
    </div>
  );
}

export function Logo({ size = 40, light = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <LogoMark size={size} />
      <div className="leading-tight">
        <div className="font-display font-extrabold text-xl tracking-tight">
          <span className={light ? "text-white" : "text-slate-900"}>InZe</span>
          <span style={{ color: light ? "#E7C15A" : "#C99A2E" }}>Air</span>
        </div>
        <div className={`text-[11px] ${light ? "text-white/80" : "text-slate-500"}`}>by Académie Bel-Air</div>
      </div>
    </div>
  );
}
